import { useQuery } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { projectedCrossKeys } from '../queries/keys';
import { projectedCrossPaths } from '../queries/paths';

// TSS vite/03 — colas de cruces proyecto de una donadora (decisión 0086 · Q-255). El
// bloque `queues` es ADITIVO en GET /admin/animals/:donorId/stats?include=queues: por
// cada cruce activo de la donadora, sus encargos (`Sale` project_pending) TOMADOS
// (cliente, preñez, fecha estimada de parto) y LIBRES (sin cubrir + vacantes por aborto).
// Read-only, permiso kpis:read. El backend materializa la cola; el front la muestra.
export function useCrossQueues(donorId) {
    return useQuery({
        queryKey: projectedCrossKeys.queues(donorId),
        queryFn:  ({ signal }) => api.get(projectedCrossPaths.donorQueues(donorId), { params: { include: 'queues' }, signal }).then(r => r.data?.queues || []),
        enabled:  !!donorId,
    });
}
